import api from './axios';

// lookups
export async function listReviewTypes() {
    const { data } = await api.get('/api/review-types');
    return data; // [{id,name},...]
}
export async function listPerformanceRatings() {
    const { data } = await api.get('/api/performance-ratings');
    return data; // [{id,name,code,description},...]
}

// mine
export async function listMyKpiReviews(reviewTypeId) {
    const { data } = await api.get('/api/reviews/mine', { params: { review_type: reviewTypeId }});
    return data; // { contract, review_type, data:[{kpi,review}] }
}

// create (upsert) or update (employee side)
export async function upsertEmployeeReview(payload) {
    // payload: { key_performance_indicator_id, review_type_id, actuals?, employee_rating_id?, employee_comments?, employee_description? }
    const { data } = await api.post('/api/reviews', payload);
    return data?.data ?? data;
}
export async function updateEmployeeReview(reviewId, payload) {
    const { data } = await api.put(`/api/reviews/${reviewId}`, payload);
    return data?.data ?? data;
}